import { render, staticRenderFns } from "./ReporteCompra.vue?vue&type=template&id=0581954d&"
import script from "./ReporteCompra.vue?vue&type=script&lang=js&"
export * from "./ReporteCompra.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCompra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports